import { observer } from 'mobx-react-lite'
import React from 'react'
import { Typography } from 'shared/ui'
import { useSmartCallFlowBuilderContext } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/context'
import { SmartCallActionNode } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/Action/ui/SmartCallActionNode/SmartCallActionNode'
import type { ISmartCallNodeProps } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/SmartCallFlowBuilderUi'
import { CallQueueStore } from '../../store/CallQueueStore'

export const CallQueueNode = observer((props: ISmartCallNodeProps) => {
  const { id } = props
  const { getActionById } = useSmartCallFlowBuilderContext()
  const store = getActionById(id)
  if (!(store instanceof CallQueueStore)) return null

  const { step } = store

  return (
    <SmartCallActionNode
      iconProps={CallQueueStore.iconProps}
      title={CallQueueStore.title}
      placeholder={'Choose an audio'}
      content={
        step.args?.greeting_message_audio_url && step.args?.greeting_music_audio_url ? (
          <Typography ariaLabel={'message'} variant={'body-md-regular'}>
            Put callers on hold
          </Typography>
        ) : null
      }
      {...props}
    />
  )
})
